import React from 'react'
import PropTypes from 'prop-types'
import BaseIcon from '../../BaseIcon/BaseIcon'
import { ReactComponent as Component } from './LinkedIn.svg'

const LinkedIn = ({ className }) => {
	return <BaseIcon component={Component} className={className} viewBox="0 0 448 512" />
}

LinkedIn.propTypes = {
	className: PropTypes.string,
}

export default LinkedIn
